export default {
  name: 'error',
  props: {
    errorCode: {
      type: Number,
      default: null
    }
  },

  data: function () {
    return {
        mutableErrorCode: JSON.parse(this.errorCode)
    }
},
  
  mounted: function () {
    this.mutableErrorCode = this.$route.params.errorCode
  },

  created: function () {
  },

  computed: {},
  methods: {}
}



// WEBPACK FOOTER //
// ./src/components/error/error.js